<app-modal-dialog [show]="showModal" (closed)="closeModalEmit()"  size="lg" position="top" #modal>
    <div class="modal-header" modal-header>
        <h3>Asignar Destino a Gasto</h3>
        <h4 class="i-hover ml-4">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h4>
    </div>
    <div class="modal-body" modal-body>
        <div class="row" *ngIf="currentExpense">
            <div class="table-responsive" style="margin-bottom: 0; overflow-y: inherit; max-height: none;">
                <table class="table table-striped" style="margin-bottom: 0; margin-top: 10px;">
                    <thead>
							<tr class="tr-middle">
								<th class="ta">
									NIT
								</th>
								<th class="limit-td">
									Proveedor
								</th>
								<th class="ta">
									Serie
								</th>
								<th class="ta">
									Número
								</th>
								<th class="ta">
									Categoría
								</th>
								<th class="ta">
									Monto
								</th>
								<th class="ta">
									Fecha Documento
								</th>
								<th class="ta">
									Fecha Ingreso
								</th>
							</tr>
						</thead>
                        <tbody>
                            <tr class="tr-middle">
                                <td class="col">
                                    {{currentExpense.nit}}
                                </td>
                                <td class="col">
                                    {{currentExpense.vendorName}}
                                </td>
                                <td class="col">
                                    {{currentExpense.series}}
                                </td>
                                <td class="col">
                                    {{currentExpense.number}}
                                </td>
                                <td class="col" style="min-width: 200px; max-width: 200px;">
                                    {{currentExpense.category}}
                                </td>
                                <td class="col">
                                    {{currentExpense.total | currency: 'Q'}}
                                </td>
                                <td class="col">
                                    {{currentExpense.date | date: 'YYYY/MM/dd'}}
                                </td>
                                <td class="col">
                                    {{currentExpense.creationDate | date: 'YYYY/MM/dd'}}
                                </td>
                            </tr>
                        </tbody>
                </table>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-12 form-group mb-4">
                        <label for="product-order" class="form-label">Destino</label>
                        <div class="input-group bg-white rounded">
                            <app-input-autocomplete
                                [allBorderRadius]="true"
                                [inputs]="inputs.destination"
                                [placeholder]="'Ingresa un destino'"
                                [filterElements]="filterDestination"
                                (inputMethod)="writeDestination($event.event)"
                                (changeStatus)="checkDestination($event.filterElement)"
                                (getTitle)="
                                    $event.filterElement.title =
                                        $event.filterElement.name
                                "
                            ></app-input-autocomplete>
                        </div>
                    </div>
                    <div class="col-12 d-flex flex-col mb-4 justify-end items-end">
                        <button class="btn btn-success" (click)="createAssociation(modal)"
                            [disabled]="loadingCreate || !verifyForm ">
                            <ng-container *ngIf="!loadingCreate">
                                <i class="fa fa-floppy-disk"></i>
                            </ng-container>
                            <ng-container *ngIf="loadingCreate">
                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                <span role="status"></span>
                            </ng-container> GUARDAR
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-modal-dialog>